/* ENUMA — Main Application JS */

let state = { reading: null, subject: null, lang: 'en', readingLang: 'en', members: 1 };
const lang = () => T[state.lang];
const langKeys = Object.keys(T);
const subjectMap = {
  spark: ['individual','children','animal'],
  blueprint: ['individual','children','animal'],
  synastria: ['couple'],
  constellation: ['family'],
  consultation: ['individual','couple','family','children']
};
// Prices come from Shopify, localized to the buyer's currency by Shopify Markets (injected as SHOPIFY_PRICES in index.liquid).
// Per-key fallback to EUR base prices so a card can never render blank if injection ever fails.
var _enumaFallbackPrices = { spark:'€50', blueprint:'€250', synastria:'€300', constellation:'€450', consultation:'€500' };
const priceMap = {};
['spark','blueprint','synastria','constellation','consultation'].forEach(function(k){
  priceMap[k] = (typeof SHOPIFY_PRICES !== 'undefined' && SHOPIFY_PRICES && SHOPIFY_PRICES[k]) ? SHOPIFY_PRICES[k] : _enumaFallbackPrices[k];
});
// v3.1: synastria + constellation return when the pair engine passes its release gate.
const readingKeys = ['spark','blueprint','consultation'];
// Reading languages = enforcement wave 1 only (per-language quality gates); re-add per shipped list.
const readingLangs = [
  { code: 'en', label: 'English' }, { code: 'es', label: 'Espa\u00f1ol' },
  { code: 'pt', label: 'Portugu\u00eas' }, { code: 'fr', label: 'Fran\u00e7ais' },
  { code: 'it', label: 'Italiano' }
];

buildLangDropdown();
buildReadings();
buildReadingLangs();

// ===============================================
// MAGNETIC SNAP: landing <-> readings ONLY
// Desktop: wheel event
// Mobile: touch swipe
// ===============================================
let snapping = false;
const landingEl = document.getElementById('landing');
const readingsEl = document.getElementById('readings');

// Desktop — wheel event
window.addEventListener('wheel', (e) => {
  if (state.reading || snapping) return;
  const scrollY = window.scrollY;
  const landingBottom = landingEl.offsetTop + landingEl.offsetHeight;
  if (scrollY < landingBottom) {
    e.preventDefault();
    snapping = true;
    if (e.deltaY > 0) {
      readingsEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setTimeout(() => { snapping = false; }, 800);
  }
}, { passive: false });

// Mobile — touch swipe
var touchStartY = 0;
var touchStartTime = 0;

window.addEventListener('touchstart', function(e) {
  touchStartY = e.touches[0].clientY;
  touchStartTime = Date.now();
}, { passive: true });

window.addEventListener('touchend', function(e) {
  if (state.reading || snapping) return;
  var touchEndY = e.changedTouches[0].clientY;
  var deltaY = touchStartY - touchEndY;
  var deltaTime = Date.now() - touchStartTime;
  if (Math.abs(deltaY) < 30 || deltaTime > 500) return;
  var scrollY = window.scrollY;
  var landingBottom = landingEl.offsetTop + landingEl.offsetHeight;
  if (scrollY < landingBottom) {
    snapping = true;
    if (deltaY > 0) {
      readingsEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setTimeout(function() { snapping = false; }, 800);
  }
}, { passive: true });

// ===============================================
// LANGUAGE
// ===============================================
function buildLangDropdown() {
  const dd = document.getElementById('langDropdown'); dd.innerHTML = '';
  langKeys.forEach(k => {
    const b = document.createElement('button');
    b.className = 'lang-option' + (k === state.lang ? ' active' : '');
    b.textContent = T[k].label;
    b.onclick = () => setLang(k);
    dd.appendChild(b);
  });
}
function toggleLangMenu() { document.getElementById('langDropdown').classList.toggle('open'); }
document.addEventListener('click', e => {
  if (!document.getElementById('langSelector').contains(e.target))
    document.getElementById('langDropdown').classList.remove('open');
});
function setLang(k) {
  state.lang = k;
  document.getElementById('langToggle').textContent = T[k].code;
  document.getElementById('langDropdown').classList.remove('open');
  buildLangDropdown(); buildReadings();
  if (state.reading) {
    if (subjectMap[state.reading].length > 1) buildSubjects(state.reading);
    if (state.subject) { buildForm(state.subject); updateSummary(); }
  }
  document.getElementById('birthLabel').textContent = lang().birth_data;
  document.getElementById('proceedBtn').textContent = lang().proceed;
  var _cn = document.getElementById('checkoutNote'); if (_cn) _cn.textContent = lang().checkout_note || 'your reading is sent to your checkout email — the Oracle completes its work within 48 hours';
  if (typeof buildTestimonials === 'function') buildTestimonials();
}

// ===============================================
// READINGS
// ===============================================
function buildReadings() {
  const g = document.getElementById('readingsGrid'); g.innerHTML = '';
  readingKeys.forEach(r => {
    const card = document.createElement('div');
    card.className = 'reading-card' + (state.reading === r ? ' selected' : '') + (state.reading && state.reading !== r ? ' dimmed' : '');
    card.onclick = () => selectReading(r);
    card.innerHTML = '<div class="reading-name">' + (r.charAt(0).toUpperCase() + r.slice(1)) + '</div>' +
      '<div class="reading-mystery">' + lang().reading_desc[r] + '</div>' +
      '<div class="reading-price">' + (r === 'consultation' ? 'from ' : '') + priceMap[r] + '</div>';
    g.appendChild(card);
  });
}

function selectReading(r) {
  if (state.reading === r) {
    state.reading = null; state.subject = null;
    buildReadings();
    hide('subject'); hide('birth'); hide('readinglang'); hide('emailsection'); hide('checkout');
    return;
  }
  state.reading = r; state.subject = null;
  buildReadings();
  // Consultation: skip subject menu, go straight to form
  if (r === 'consultation') {
    hide('subject'); hide('readinglang'); hide('emailsection'); hide('checkout');
    selectSubject('individual');
    return;
  }
  const subs = subjectMap[r];
  if (subs.length === 1) {
    hide('subject'); hide('readinglang'); hide('emailsection'); hide('checkout');
    selectSubject(subs[0]);
  } else {
    buildSubjects(r);
    show('subject'); hide('birth'); hide('readinglang'); hide('emailsection'); hide('checkout');
    smoothTo('subject');
  }
}

// ===============================================
// SUBJECTS
// ===============================================
function buildSubjects(reading) {
  const el = document.getElementById('subject-options'), subs = subjectMap[reading];
  el.innerHTML = '';
  subs.forEach(s => {
    const c = document.createElement('div');
    c.className = 'subject-card' + (state.subject === s ? ' selected' : '');
    c.onclick = () => selectSubject(s);
    c.innerHTML = '<div class="subject-name">' + lang().subject[s] + '</div>';
    el.appendChild(c);
  });
}

function selectSubject(id) {
  state.subject = id;
  if (subjectMap[state.reading].length > 1) buildSubjects(state.reading);
  buildForm(id);
  show('birth'); show('readinglang'); show('emailsection'); show('checkout'); updateSummary();
  document.getElementById('birthLabel').textContent = lang().birth_data;
  document.getElementById('proceedBtn').textContent = lang().proceed;
  document.getElementById('readingLangLabel').textContent = state.reading === 'consultation' ? (lang().consultation_language || 'Consultation language') : (lang().reading_language || 'Reading language');
  smoothTo('birth');
}

// ===============================================
// BIRTH FORM
// ===============================================
function buildForm(sid) {
  const c = document.getElementById('birth-forms'); c.innerHTML = '';
  const f = lang().form;

  // Consultation: special flow — inquirer + optional extra people + free-form
  if (state.reading === 'consultation') {
    var l = lang();
    state.consultExtra = 0;
    // Inquirer birth data
    c.appendChild(pb(l.consult_you || 'You', 1));
    // Add person button (max 5 extra)
    var addBtn = mbtn(l.consult_add_person || '+ Add another person', function() {
      if (state.consultExtra >= 5) return;
      state.consultExtra++;
      var pLabel = (l.consult_person || 'Person') + ' ' + state.consultExtra;
      c.insertBefore(pb(pLabel, state.consultExtra + 1), addBtn);
      if (state.consultExtra >= 5) addBtn.style.display = 'none';
    });
    c.appendChild(addBtn);
    // Free-form: About you
    var aboutBlock = document.createElement('div');
    aboutBlock.className = 'consult-block';
    aboutBlock.innerHTML = '<p class="consult-label">' + (l.consult_about || 'About you') + '</p>' +
      '<p class="consult-hint">' + (l.consult_about_hint || 'profession, relationships, family \u2014 whatever helps us understand your world') + '</p>' +
      '<textarea class="consult-textarea" id="consultAbout"></textarea>';
    c.appendChild(aboutBlock);
    // Free-form: What brings you here
    var reasonBlock = document.createElement('div');
    reasonBlock.className = 'consult-block';
    reasonBlock.innerHTML = '<p class="consult-label">' + (l.consult_reason || 'What brings you here') + '</p>' +
      '<p class="consult-hint">' + (l.consult_reason_hint || 'questions, concerns, what you\'d like to explore') + '</p>' +
      '<textarea class="consult-textarea" id="consultReason"></textarea>';
    c.appendChild(reasonBlock);
    return;
  }

  if (sid === 'individual') c.appendChild(pb('', 1));
  else if (sid === 'children') {
    c.appendChild(pb(f.child, 1)); c.appendChild(pb(f.parent1, 2));
    const b = mbtn(f.add_parent, () => { c.insertBefore(pb(f.parent2, 3), b); b.remove(); });
    c.appendChild(b);
  }
  else if (sid === 'animal') c.appendChild(pb('', 1, true));
  else if (sid === 'couple') { c.appendChild(pb(f.person + ' 1', 1)); c.appendChild(pb(f.person + ' 2', 2)); }
  else if (sid === 'family') {
    state.members = 3;
    for (let i = 1; i <= 3; i++) c.appendChild(pb(f.member + ' ' + i, i));
    const b = mbtn(f.add_member, () => { state.members++; c.insertBefore(pb(f.member + ' ' + state.members, state.members), b); });
    c.appendChild(b);
  }
}

function mbtn(t, fn) {
  const b = document.createElement('button');
  b.className = 'add-member-btn'; b.textContent = t; b.onclick = fn; return b;
}

function pb(label, idx, animal) {
  animal = animal || false;
  const b = document.createElement('div'); b.className = 'person-block';
  const f = lang().form;
  const nm = animal ? f.name : f.full_name;
  const g = animal
    ? '<option value="">—</option><option value="male">' + f.male + '</option><option value="female">' + f.female + '</option>'
    : '<option value="">—</option><option value="female">' + f.female + '</option><option value="male">' + f.male + '</option><option value="other">' + f.other + '</option>';
  b.innerHTML = (label ? '<p class="person-label">' + label + '</p>' : '') +
    '<div class="form-row full"><div class="form-group"><span>' + nm + '</span><input type="text"></div></div>' +
    '<div class="form-row">' +
      enumaDateField(f.birth_date) +
      '<div class="form-group">' +
        '<div class="time-header">' +
          '<span>' + f.birth_time + '</span>' +
          '<button type="button" class="time-toggle" id="tbtn' + idx + '" onclick="toggleUnknown(' + idx + ')">' +
            '<div class="box"></div><span class="lbl">' + f.unknown + '</span>' +
          '</button>' +
        '</div>' +
        '<input type="time" id="t' + idx + '">' +
      '</div>' +
    '</div>' +
    '<div class="form-row">' +
      '<div class="form-group"><span>' + f.birth_city + '</span><input type="text"></div>' +
      '<div class="form-group"><span>' + f.birth_country + '</span><input type="text"></div>' +
    '</div>' +
    '<div class="form-row full"><div class="form-group"><span>' + f.gender + '</span><select>' + g + '</select></div></div>';
  return b;
}

function toggleUnknown(i) {
  const btn = document.getElementById('tbtn' + i);
  const input = document.getElementById('t' + i);
  btn.classList.toggle('checked');
  const isChecked = btn.classList.contains('checked');
  input.disabled = isChecked;
  input.style.opacity = isChecked ? '0.2' : '1';
  if (isChecked) input.value = '';
}

// ===============================================
// READING LANGUAGE
// ===============================================
function buildReadingLangs() {
  const el = document.getElementById('readingLangPills'); el.innerHTML = '';
  readingLangs.forEach(l => {
    const b = document.createElement('button');
    b.className = 'rlang-pill' + (state.readingLang === l.code ? ' selected' : '');
    b.textContent = l.label;
    b.onclick = () => { state.readingLang = l.code; buildReadingLangs(); updateSummary(); };
    el.appendChild(b);
  });
}

// ===============================================
// READING TYPE RESOLUTION
// Maps (state.reading, state.subject) -> pipeline reading_type code
// ===============================================
function resolveReadingType(reading, subject) {
  const map = {
    'spark|individual':    'spark',
    'spark|children':      'spark_children',
    'spark|animal':        'spark_animal',
    'blueprint|individual':'natal',
    'blueprint|children':  'children',
    'blueprint|animal':    'animal',
    'synastria|couple':    'synastry',
    'constellation|family':'constellation'
  };
  if (reading === 'consultation') return 'consultation';
  return map[reading + '|' + subject] || 'natal';
}

// ===============================================
// CHECKOUT — Shopify Cart API Integration
// ===============================================
function updateSummary() {
  const r = state.reading ? state.reading[0].toUpperCase() + state.reading.slice(1) : '';
  const p = state.reading ? priceMap[state.reading] : '';
  const rl = readingLangs.find(l => l.code === state.readingLang);
  document.getElementById('checkout-summary').textContent = r + ' \u00b7 ' + p + ' \u00b7 ' + (rl ? rl.label : 'English');
}

function handleCheckout() {
  const btn = document.getElementById('proceedBtn');
  const originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = '\u00b7\u00b7\u00b7';

  // 1. Collect all person blocks from DOM
  var blocks = document.querySelectorAll('#birth-forms .person-block');
  var people = [];

  for (var i = 0; i < blocks.length; i++) {
    var block = blocks[i];
    var inputs = block.querySelectorAll('input');
    var selects = block.querySelectorAll('select');

    // Inputs order: [0] name, [1] date, [2] time, [3] city, [4] country
    var fullName = inputs[0] ? inputs[0].value.trim() : '';
    var birthDate = inputs[1] ? inputs[1].value : '';
    var birthTimeInput = inputs[2];
    var birthCity = inputs[3] ? inputs[3].value.trim() : '';
    var birthCountry = inputs[4] ? inputs[4].value.trim() : '';
    var gender = selects[0] ? selects[0].value : '';

    // Check if "unknown" toggle is checked for this person
    var timeToggle = block.querySelector('.time-toggle.checked');
    var birthTime = timeToggle ? 'unknown' : (birthTimeInput ? birthTimeInput.value : '');

    people.push({
      fullName: fullName,
      birthDate: birthDate,
      birthTime: birthTime,
      birthCity: birthCity,
      birthCountry: birthCountry,
      gender: gender
    });
  }

  // 2. Validate: each person needs name, date, city at minimum
  for (var j = 0; j < people.length; j++) {
    var p = people[j];
    if (!p.fullName || !p.birthDate || !p.birthCity) {
      btn.disabled = false;
      btn.textContent = originalText;
      smoothTo('birth');
      return;
    }
  }

  // 3. Build Shopify line item properties
  var properties = {};
  var isSingle = (people.length === 1);

  if (isSingle) {
    var person = people[0];
    properties['full name']     = person.fullName;
    properties['birth date']    = person.birthDate;
    properties['birth time']    = person.birthTime || 'unknown';
    properties['birth city']    = person.birthCity;
    properties['birth country'] = person.birthCountry || 'Unknown';
    properties['gender']        = person.gender;
  } else {
    for (var k = 0; k < people.length; k++) {
      var pp = people[k];
      var prefix = 'person ' + (k + 1) + ' ';
      properties[prefix + 'full name']     = pp.fullName;
      properties[prefix + 'birth date']    = pp.birthDate;
      properties[prefix + 'birth time']    = pp.birthTime || 'unknown';
      properties[prefix + 'birth city']    = pp.birthCity;
      properties[prefix + 'birth country'] = pp.birthCountry || 'Unknown';
      properties[prefix + 'gender']        = pp.gender;
    }
  }

  // 4. Add metadata
  var readingType = resolveReadingType(state.reading, state.subject);
  properties['reading type'] = readingType;
  properties['language']     = state.readingLang;

  // 4b. Add consultation-specific fields
  if (state.reading === 'consultation') {
    var aboutEl = document.getElementById('consultAbout');
    var reasonEl = document.getElementById('consultReason');
    if (aboutEl && aboutEl.value.trim()) properties['about you'] = aboutEl.value.trim();
    if (reasonEl && reasonEl.value.trim()) properties['what brings you here'] = reasonEl.value.trim();
  }

  // 5. Determine Shopify variant ID
  var variantId = SHOPIFY_VARIANTS[state.reading];
  if (!variantId) {
    console.error('No variant ID for reading:', state.reading);
    btn.disabled = false;
    btn.textContent = originalText;
    return;
  }

  // 6. Clear cart first (prevent stale items from previous selections)
  fetch('/cart/clear.js', { method: 'POST' })
  .then(function() {
    // 7. Add to cart
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: properties
        }]
      })
    });
  })
  .then(function(response) {
    if (!response.ok) {
      return response.json().then(function(err) { throw new Error(err.description || 'Cart error'); });
    }
    return response.json();
  })
  .then(function() {
    // 8. Redirect to Shopify checkout
    window.location.href = '/checkout';
  })
  .catch(function(err) {
    console.error('Checkout failed:', err);
    btn.disabled = false;
    btn.textContent = originalText;
  });
}

// ===============================================
// UTILITY
// ===============================================
function smoothTo(id) { setTimeout(function() { document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150); }
function show(id) { var e = document.getElementById(id); if (e) e.classList.remove('collapsed'); }
function hide(id) { var e = document.getElementById(id); if (e) e.classList.add('collapsed'); }

// Asset protection — block right-click save on images
document.addEventListener('contextmenu', function(e) {
  if (e.target.tagName === 'IMG' || e.target.closest('.bg-fixed')) e.preventDefault();
});

// ===============================================
// CUSTOM BIRTH-DATE PICKER  (replaces native <input type="date">)
// On-brand calendar with instant year/month jump — built for birthdates,
// not appointments: tapping the year scrolls straight to any decade.
// CONTRACT: emits exactly ONE <input> (hidden, .dp-value, "YYYY-MM-DD"),
// keeping the collector's index map valid: [name, date, time, city, country].
// The calendar UI is buttons/divs only — never <input> — so indices don't shift.
// Localized month/weekday names come from Intl using the active UI language.
// ===============================================
(function () {
  var MIN_YEAR = 1900;
  var _seq = 0;
  var _state = {}; // id -> { y, m, view:'days'|'months'|'years', sel:{y,m,d}|null }

  function loc() {
    try { new Intl.DateTimeFormat(state.lang).format(new Date()); return state.lang; }
    catch (e) { return 'en'; }
  }
  function now() { var d = new Date(); return { y: d.getFullYear(), m: d.getMonth(), d: d.getDate() }; }
  function maxYear() { return now().y; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  var FALLBACK_M = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function monthLong(m) {
    try { return new Intl.DateTimeFormat(loc(), { month: 'long' }).format(new Date(2000, m, 1)); }
    catch (e) { return FALLBACK_M[m]; }
  }
  function monthShort(m) {
    try { return new Intl.DateTimeFormat(loc(), { month: 'short' }).format(new Date(2000, m, 1)); }
    catch (e) { return FALLBACK_M[m].slice(0, 3); }
  }
  function weekdayCells() {
    var out = [];
    for (var i = 0; i < 7; i++) {
      var d = new Date(2000, 0, 3 + i); // Jan 3 2000 = Monday → Monday-first week
      var s;
      try { s = new Intl.DateTimeFormat(loc(), { weekday: 'short' }).format(d); }
      catch (e) { s = ['Mo','Tu','We','Th','Fr','Sa','Su'][i]; }
      out.push(s.replace('.', '').slice(0, 2));
    }
    return out;
  }
  function placeholder() {
    try {
      var parts = new Intl.DateTimeFormat(loc(), { day: '2-digit', month: 'short', year: 'numeric' }).formatToParts(new Date(2000, 0, 1));
      return parts.map(function (p) {
        if (p.type === 'day') return 'DD';
        if (p.type === 'month') return 'MMM';
        if (p.type === 'year') return 'YYYY';
        return p.value;
      }).join('');
    } catch (e) { return 'DD MMM YYYY'; }
  }
  function fmt(y, m, d) {
    try { return new Intl.DateTimeFormat(loc(), { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(y, m, d)); }
    catch (e) { return d + ' ' + monthShort(m) + ' ' + y; }
  }

  // Markup injected by pb(). Outputs a .form-group identical in shape to the
  // other fields, with the canonical value carried by a hidden <input>.
  window.enumaDateField = function (label) {
    var id = 'dp' + (++_seq);
    return '<div class="form-group">'
      + '<span>' + label + '</span>'
      + '<div class="enuma-date" data-dp="' + id + '">'
      +   '<button type="button" class="dp-trigger"><span class="dp-display dp-empty">' + placeholder() + '</span></button>'
      +   '<input type="hidden" class="dp-value">'
      +   '<div class="dp-pop" hidden></div>'
      + '</div>'
      + '</div>';
  };

  function freshState(root) {
    var sel = null;
    var v = root.querySelector('.dp-value').value;
    var mt = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
    if (mt) sel = { y: +mt[1], m: +mt[2] - 1, d: +mt[3] };
    var start = sel ? { y: sel.y, m: sel.m } : { y: maxYear() - 30, m: 0 };
    return { y: start.y, m: start.m, view: sel ? 'days' : 'years', sel: sel };
  }

  function cell(act, val, cls, txt, disabled) {
    return '<button type="button" class="' + cls + '" data-act="' + act + '" data-val="' + val + '"'
      + (disabled ? ' disabled' : '') + '>' + txt + '</button>';
  }
  function nav(act) {
    return '<button type="button" class="dp-nav" data-act="' + act + '" aria-label="' + act + '">'
      + (act.charAt(0) === 'p' ? '‹' : '›') + '</button>';
  }

  function render(root) {
    var st = _state[root.getAttribute('data-dp')];
    var pop = root.querySelector('.dp-pop');
    var t = now();
    var html = '';

    if (st.view === 'years') {
      html += '<div class="dp-grid dp-years">';
      for (var y = maxYear(); y >= MIN_YEAR; y--) {
        var ysel = st.sel && st.sel.y === y;
        html += cell('year', y, 'dp-cell dp-year' + (ysel ? ' sel' : '') + (y === t.y ? ' today' : ''), y, false);
      }
      html += '</div>';
    } else if (st.view === 'months') {
      html += '<div class="dp-head">' + nav('py')
        + '<button type="button" class="dp-ctx" data-act="toyears">' + st.y + '</button>' + nav('ny') + '</div>';
      html += '<div class="dp-grid dp-months">';
      for (var mo = 0; mo < 12; mo++) {
        var mfuture = (st.y > t.y) || (st.y === t.y && mo > t.m);
        var msel = st.sel && st.sel.y === st.y && st.sel.m === mo;
        html += cell('month', mo, 'dp-cell dp-month' + (msel ? ' sel' : ''), monthShort(mo), mfuture);
      }
      html += '</div>';
    } else {
      html += '<div class="dp-head">' + nav('pm')
        + '<button type="button" class="dp-ctx" data-act="tomonths">' + monthLong(st.m) + ' ' + st.y + '</button>' + nav('nm') + '</div>';
      html += '<div class="dp-week">';
      weekdayCells().forEach(function (w) { html += '<span>' + w + '</span>'; });
      html += '</div><div class="dp-grid dp-days">';
      var firstDow = (new Date(st.y, st.m, 1).getDay() + 6) % 7;
      var dim = new Date(st.y, st.m + 1, 0).getDate();
      for (var b = 0; b < firstDow; b++) html += '<span class="dp-pad"></span>';
      for (var d = 1; d <= dim; d++) {
        var dfuture = (st.y > t.y) || (st.y === t.y && st.m > t.m) || (st.y === t.y && st.m === t.m && d > t.d);
        var dsel = st.sel && st.sel.y === st.y && st.sel.m === st.m && st.sel.d === d;
        var dtoday = (st.y === t.y && st.m === t.m && d === t.d);
        html += cell('day', d, 'dp-cell dp-day' + (dsel ? ' sel' : '') + (dtoday ? ' today' : ''), d, dfuture);
      }
      html += '</div>';
    }
    pop.innerHTML = html;

    if (st.view === 'years') {
      var tgt = pop.querySelector('.dp-year.sel') || pop.querySelector('.dp-year[data-val="' + (maxYear() - 30) + '"]');
      if (tgt) tgt.scrollIntoView({ block: 'center' });
    }
  }

  function closeOne(root) {
    root.classList.remove('open');
    root.querySelector('.dp-pop').hidden = true;
    root.querySelector('.dp-trigger').setAttribute('aria-expanded', 'false');
  }
  function closeAll(except) {
    var open = document.querySelectorAll('.enuma-date.open');
    for (var i = 0; i < open.length; i++) if (open[i] !== except) closeOne(open[i]);
  }
  function openOne(root) {
    closeAll(root);
    _state[root.getAttribute('data-dp')] = freshState(root); // re-sync from hidden value
    root.classList.add('open');
    root.querySelector('.dp-pop').hidden = false;
    root.querySelector('.dp-trigger').setAttribute('aria-expanded', 'true');
    render(root);
  }

  function commit(root, sel) {
    var hidden = root.querySelector('.dp-value');
    hidden.value = sel.y + '-' + pad(sel.m + 1) + '-' + pad(sel.d);
    var disp = root.querySelector('.dp-display');
    disp.textContent = fmt(sel.y, sel.m, sel.d);
    disp.classList.remove('dp-empty');
    try { hidden.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.dp-trigger');
    if (trigger) {
      e.preventDefault();
      var r = trigger.closest('.enuma-date');
      if (r.classList.contains('open')) closeOne(r); else openOne(r);
      return;
    }
    var actEl = e.target.closest && e.target.closest('[data-act]');
    if (actEl && actEl.closest('.dp-pop')) {
      e.preventDefault();
      var root = actEl.closest('.enuma-date');
      var st = _state[root.getAttribute('data-dp')];
      var act = actEl.getAttribute('data-act');
      var val = +actEl.getAttribute('data-val');
      if (act === 'pm') { if (--st.m < 0) { st.m = 11; st.y--; } }
      else if (act === 'nm') { if (++st.m > 11) { st.m = 0; st.y++; } }
      else if (act === 'py') { st.y--; }
      else if (act === 'ny') { st.y++; }
      else if (act === 'toyears') { st.view = 'years'; }
      else if (act === 'tomonths') { st.view = 'months'; }
      else if (act === 'year') { st.y = val; st.view = 'months'; }
      else if (act === 'month') { st.m = val; st.view = 'days'; }
      else if (act === 'day') { st.sel = { y: st.y, m: st.m, d: val }; commit(root, st.sel); closeOne(root); return; }
      if (st.y < MIN_YEAR) st.y = MIN_YEAR;
      if (st.y > maxYear()) st.y = maxYear();
      render(root);
      return;
    }
    if (!(e.target.closest && e.target.closest('.enuma-date'))) closeAll(null);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeAll(null); });
})();
